import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useContext } from "react";
export const TabContext = createContext(undefined);
export const useTab = () => {
    const context = useContext(TabContext);
    if (!context)
        throw new Error("useTab must be use inside Tab Provider(<GrTab.Group>)");
    return context;
};
export const TabProvider = ({ children, value, color }) => {
    return _jsx(TabContext.Provider, { value: { value, color }, children: children });
};
//# sourceMappingURL=tabContext.js.map